import { useState, useEffect } from "react";
import axios from "axios";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import { useNavigate } from "react-router-dom";
import ExcelExport from "../../../components/ExcelExport/ExcelExportAccounts";
import Wrapper from "../../../components/UI/Wrapper";

import SalesIcon from "../../../Icons/SalesAmount.png";
import RatioIcon from "../../../Icons/Ratio.png";

const FINANCIAL_YEARS = [
    "2026 - 2027",
    "2025 - 2026",
    "2024 - 2025",
    "2023 - 2024",
    "2022 - 2023",
    "2021 - 2022",
];

const extractYear = (fy) => fy.split(" - ")[0].trim();

const fmt = (val) => {
    const num = Number(val || 0);

    if (num === 0) return "₹ 0";

    return num < 0
        ? `- ₹ ${Math.abs(num).toLocaleString("en-IN")}`
        : `₹ ${num.toLocaleString("en-IN")}`;
};

const fmtSummary = (val) =>
    !val ? "₹ 0" : "₹ " + Number(val).toLocaleString("en-IN");


const ProfitAndLoss = () => {

  const navigate = useNavigate();

  const baseAPI = process.env.REACT_APP_API_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));

  const [fy, setFy] = useState(FINANCIAL_YEARS[0]);

  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);

  const [loading, setLoading] = useState(false);

  const headers = {
    Authorization: `Bearer ${storedToken}`,
    "Content-Type": "application/json",
  };

  const fetchReport = async (selectedFy) => {

    setLoading(true);

    try {

      const financialYear = extractYear(selectedFy);

      const [summaryRes, detailRes] = await Promise.all([
        axios.get(
          `${baseAPI}userget/GetProfitLossReportSummary?FinancialYear=${financialYear}`,
          { headers }
        ),

        axios.get(
          `${baseAPI}userget/GetProfitLossReportDetail?FinancialYear=${financialYear}`,
          { headers }
        ),
      ]);

      setSummary(summaryRes?.data?.data?.[0] || null);

      setRows(detailRes?.data?.data || []);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  useEffect(() => {
    fetchReport(fy);
  }, [fy]);

  const totals = rows.reduce(
    (acc, r) => ({
      sales: acc.sales + Number(r.Sales || 0),
      grossSales: acc.grossSales + Number(r.GrossSales || 0),
      cogs: acc.cogs + Number(r.CostOfGoodSold || 0),
      gp: acc.gp + Number(r.GrossProfitYearly || 0),
      operationCost:
        acc.operationCost + Number(r.OperationCostYearly || 0),
      netProfit:
        acc.netProfit + Number(r.NetProfitYearly || 0),
    }),
    {
      sales: 0,
      grossSales: 0,
      cogs: 0,
      gp: 0,
      operationCost: 0,
      netProfit: 0,
    }
  );

  const totalRatio = totals.sales
    ? Math.round((totals.gp / totals.sales) * 100)
    : 0;

  return (
    <div>
      <div className="app-container-viewLeadDetails">

        <MiniDrawer />

        <div
          style={{ overflowX: "hidden" }}
          className="container-fluid container-viewLeadDetails"
        >

          {/* HEADER */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
            className="country-header"
          >

            <div>
              <h1 style={{ fontSize: "24px" }}>
                <b>Profit & Loss</b> |{" "}
                <HomeOutlinedIcon /> &gt;

                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/dashboard")}
                >
                  Accounts & Finance
                </a>

                <span style={{ fontSize: "20px" }}>
                  {" "} &gt; Reports
                </span>

                <span style={{ fontSize: "20px" }}>
                  {" "} &gt; Profit & Loss
                </span>
              </h1>
            </div>
          </div>

          {/* FILTERS */}

          <div className="container-fluid px-3 py-2">

            <div
              className="mt-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >

              <select
                value={fy}
                onChange={(e) => setFy(e.target.value)}
                className="form-select"
                style={{
                  width: "220px",
                  borderRadius: "8px",
                }}
              >
                {FINANCIAL_YEARS.map((y) => (
                  <option key={y}>{y}</option>
                ))}
              </select>

              <div style={{ display: "flex" }}>
                <ExcelExport />
              </div>
            </div>

            <hr
              style={{
                marginTop: "20px",
                padding: "0px",
                marginBottom: "30px",
              }}
            />

            {/* KPI SECTION */}

            <Wrapper className="p-4">

              <div
                className="p-4"
                style={{
                  backgroundColor: "#5B489D1A",
                  borderRadius: "12px",
                }}
              >

                <div className="row">

                  {/* SALES */}

                  <div className="col-3 px-0">

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >

                      <img
                        style={{
                          width: "55px",
                          height: "55px",
                          padding: "6px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="img-fluid"
                        src={SalesIcon}
                      />

                      <div className="px-2">

                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "#3D3D3D",
                            margin: "0px",
                          }}
                        >
                          Total Sales Amount
                        </h6>

                        <h5
                          style={{
                            color: "#5B489D",
                            fontWeight: "bold",
                          }}
                        >
                          {fmtSummary(summary?.TotalSales)}
                        </h5>

                      </div>
                    </div>
                  </div>

                  {/* COGS */}

                  <div className="col-3 px-0">

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >

                      <img
                        style={{
                          width: "55px",
                          height: "55px",
                          padding: "6px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="img-fluid"
                        src={SalesIcon}
                      />

                      <div className="px-2">

                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            margin: "0px",
                          }}
                        >
                          Total C.O.G.S Amount
                        </h6>

                        <h5
                          style={{
                            color: "#5B489D",
                            fontWeight: "bold",
                          }}
                        >
                          {fmtSummary(summary?.TotalCOGS)}
                        </h5>

                      </div>
                    </div>
                  </div>

                  {/* GP */}

                  <div className="col-3 px-0">

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >

                      <img
                        style={{
                          width: "55px",
                          height: "55px",
                          padding: "6px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="img-fluid"
                        src={SalesIcon}
                      />

                      <div className="px-2">

                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            margin: "0px",
                          }}
                        >
                          Total G.P Amount
                        </h6>

                        <h5
                          style={{
                            color: "#5B489D",
                            fontWeight: "bold",
                          }}
                        >
                          {fmtSummary(summary?.TotalGrossProfit)}
                        </h5>

                      </div>
                    </div>
                  </div>

                  {/* GP RATIO */}

                  <div className="col-3 px-0">

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >

                      <img
                        style={{
                          width: "55px",
                          height: "55px",
                          padding: "6px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="img-fluid"
                        src={RatioIcon}
                      />

                      <div className="px-2">

                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            margin: "0px",
                          }}
                        >
                          Total G.P Ratio
                        </h6>

                        <h5
                          style={{
                            color: "#5B489D",
                            fontWeight: "bold",
                          }}
                        >
                          {summary?.TotalGPRatio || 0}%
                        </h5>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Wrapper>

            <br />

            {/* TABLE */}

            <div className="expenseList">

              <h2
                className="Venderheading"
                style={{
                  fontSize: "22px",
                  paddingLeft: "16px",
                  paddingTop: "7px",
                }}
              >
                Profit & Loss
              </h2>

              <div style={{ overflowX: "auto" }}>

                <table
                  style={{ width: "100%", minWidth: "1400px" }}
                  className="table_expense"
                >

                  <thead>

                    <tr className="expenseListHeading">

                      <th>S.No.</th>
                      <th>Shipment Type</th>
                      <th>Sales</th>
                      <th>Gross Sales</th>
                      <th>Cost Of Goods Sold</th>
                      <th>Gross Profit Yearly</th>
                      <th>Operation Cost Yearly</th>
                      <th>Net Profit Yearly</th>
                      <th>Gross Profit Ratio</th>

                    </tr>

                  </thead>

                  <tbody>

                    {loading ? (

                      <tr>
                        <td colSpan="9" style={{ textAlign: "center" }}>
                          Loading...
                        </td>
                      </tr>

                    ) : rows.length > 0 ? (

                      rows.map((row, index) => (

                        <tr key={index}>

                          <td>{index + 1}</td>

                          <td>{row.ShipmentType}</td>

                          <td>{fmt(row.Sales)}</td>

                          <td>{fmt(row.GrossSales)}</td>

                          <td>{fmt(row.CostOfGoodSold)}</td>

                          <td>{fmt(row.GrossProfitYearly)}</td>

                          <td>{fmt(row.OperationCostYearly)}</td>

                          <td>{fmt(row.NetProfitYearly)}</td>

                          <td>
                            {row.GrossProfitRatio}%
                          </td>

                        </tr>

                      ))

                    ) : (

                      <tr>
                        <td colSpan="9" style={{ textAlign: "center" }}>
                          No Data Found
                        </td>
                      </tr>

                    )}

                  </tbody>

                  {/* FOOTER */}

                  {rows.length > 0 && (

                    <tfoot>

                      <tr
                        style={{
                          background: "#f3f1fc",
                          fontWeight: "bold",
                        }}
                      >

                        <td colSpan="2">
                          Total
                        </td>

                        <td>{fmt(totals.sales)}</td>

                        <td>{fmt(totals.grossSales)}</td>

                        <td>{fmt(totals.cogs)}</td>

                        <td>{fmt(totals.gp)}</td>

                        <td>{fmt(totals.operationCost)}</td>

                        <td>{fmt(totals.netProfit)}</td>

                        <td>{totalRatio}%</td>

                      </tr>

                    </tfoot>

                  )}

                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitAndLoss;



